import MainLayout from 'components/layout/MainLayout';
import css from 'styled-jsx/css';
import { colors } from 'utils/constants';
import HeroSection from 'components/HeroSection';
import GlowBar from 'components/GlowBar';
import RoundedButton from 'components/RoundedButton';
import { NextSeo } from 'next-seo';

const Affiliates = () => {
  return (
    <MainLayout>
      <NextSeo
        title="Become An Affiliate | DAYMADE"
        openGraph={{
          title: 'Become An Affiliate | DAYMADE',
        }}
      />

      <HeroSection height="350px">
        <h1
          style={{
            color: colors.brand.neon,
            textShadow: `0 0 8px ${colors.brand.shadow}`,
            paddingTop: '100px',
          }}
        >
          Become an <span className="blueOutlineText">affiliate</span>
        </h1>
      </HeroSection>

      <div className="paddedMaxWidthContainer" style={{ padding: '2em' }}>
        <div className="container">
          <h3>Help spread the DAYMADE buzz, get rewarded </h3>
          <p>
            Love DAYMADE and want to help widen our reach by spreading the word?
            You can earn commission for each new person who signs up for a
            DAYMADE subscription! More players, more winners & trees planted!
          </p>
          <p>
            To help make this is beneficial partnership for both parties, here’s
            what’s important:
          </p>

          <ol>
            <li>
              You must have an audience that is predominantly based in the UK,
              as we operate in the UK only
            </li>
            <li>
              If you wish to promote us on your social media (Instagram/TikTok),
              you must have at least 1,000 followers
            </li>
          </ol>
          <p>Interested? Apply below</p>
          <RoundedButton
            href="https://bi5hrr2xaai.typeform.com/to/mDNsDYg8"
            style={{ width: '100%', maxWidth: '300px', marginTop: '20px' }}
          >
            SIGN UP NOW
          </RoundedButton>
        </div>
      </div>

      <style jsx>{styles}</style>
      <GlowBar color="rgba(94, 254, 223, 0.35)" direction="up" height="25px" />
    </MainLayout>
  );
};

const styles = css`
  .container {
    width: 100%;
    padding-top: 20px;
    margin-bottom: 20px;
  }

  p,
  h2,
  h3,
  h4 {
    text-align: left;
  }

  p,
  li {
    font-weight: 500;
  }

  li {
    margin: 7px 0;
  }

  @media (min-width: 900px) {
    p,
    li {
      font-size: 14px;
    }

    li {
      margin: 5px 0;
    }
  }

  :global(.footer) {
    margin-top: 0 !important;
  }
`;

export default Affiliates;
